import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { Exec07Data } from "../../../../interfaces/entities/Exec07Data";
import { formatStringToReais } from "../../../../utils/MoneyFormat";
import "./styles.css";

const Exec07Detalhes: React.FC<{ data: Exec07Data }> = ({ data }) => {
  const accessibility = useAccessibility();

  return (
    <div className="procedimento-data-card" style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
      {
        data.valorCirurgiao &&
        <div style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Cirurgião</span>
          <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{formatStringToReais(data.valorCirurgiao)}</span>
        </div>
      }
      {
        data.valorAnestesista &&
        <div style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
          <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Anestesista</span>
          <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{formatStringToReais(data.valorAnestesista)}</span>
        </div>
      }
      {
        data.valoresAuxiliares.map((v, i) => {
          return (
            v.valorAuxiliar && v.valorAuxiliar !== "0" &&
            <div key={i} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
              <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Auxiliar {i+1}</span>
              <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{formatStringToReais(v.valorAuxiliar)}</span>
            </div>
          )
        })
      }
      <div style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility}}>
        <span className="procedimento-data-key" style={accessibility.textStyleAccessibility}>Valor total de tabela</span>
        <span className="procedimento-data-value" style={accessibility.textStyleAccessibility}>{formatStringToReais(data.valorTotal)}</span>
      </div>
    </div>
  )
}

export default Exec07Detalhes;